<template>
  <v-flex d-inline-flex align-center>
    <v-flex class="title-0" d-flex align-baseline>
      <v-flex class="title-1">
        <h1>CTG</h1>
      </v-flex>
      <v-flex class="version-style">
        {{ versionApp }}
      </v-flex>
    </v-flex>
    <v-flex class="brand-style" pl-3>
      <v-img
        :src="require('../assets/logo-blanco-experis.svg')"
        contain
        height="42"
      ></v-img>
    </v-flex>
    <v-flex class="title-2" ml-2 pl-2>
      <h4>SERVICE TICKET</h4>
    </v-flex>
    <v-flex>
      <router-link v-if="role > 1" to="/ods">Service Tickets</router-link>
      <router-link v-else-if="role < 2 || role !== 'SuperAdmin'" to="/">
        Eventos
      </router-link>
      <router-link
        v-if="
          email === 'ysk8.testing@gmail.com' ||
            email === 'sergio.perez@totumo.net' ||
            role === 'SuperAdmin'
        "
        to="/admin"
      >
        Administrador
      </router-link>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HeaderAll",
  computed: {
    ...mapGetters(["role", "email", "versionApp"])
  },
  mounted() {
    // console.log("ROLE: ", this.role);
  }
};
</script>

<style lang="stylus" scoped>
h1
  font-size 36px

h4
  font-size 18px
  font-weight 400

a
  text-decoration none
  color white
  padding-left 15px
  padding-right 15px
  font-size 18px
  border-left solid 1px rgba(255, 255, 255, 0.5)

a:hover
  opacity 0.7

.version-style
  font-size 8px
  color rgba(255, 255, 255, 0.5)

.title-0
  max-width 100px
  min-width 100px

.title-1
  max-width 70px
  min-width 70px

.brand-style
  max-width 125px
  min-width 125px

.title-2
  max-width 200px
  min-width 200px
  border-left solid 1px rgba(255, 255, 255, 0.5)
</style>
